import type {
  CopilotContext,
  CopilotContextDataEntry,
} from "src/clients/agent-management";
import { useWorkspaceAndOrg } from "src/utils/useCurrentWorkspace";

export type ClientContextData = {
  organizationName: string | undefined;
  workspaceName: string | undefined;
};

export const clientContextData = ({
  organizationName,
  workspaceName,
}: ClientContextData): CopilotContextDataEntry[] => [
  ...(organizationName
    ? [
        {
          key: "organization_name",
          value: organizationName,
          description:
            "Name of the Taktile organization the user is currently working in.",
        },
      ]
    : []),
  ...(workspaceName
    ? [
        {
          key: "workspace_name",
          value: workspaceName,
          description:
            "Name of the Taktile workspace the user is currently working in.",
        },
      ]
    : []),
];

export const withClientContextData = (
  context: CopilotContext,
  data: ClientContextData,
): CopilotContext => ({
  ...context,
  data: [...(context.data ?? []), ...clientContextData(data)],
});

export const useClientContextData = (): ClientContextData => {
  const { org, workspace } = useWorkspaceAndOrg();

  return {
    organizationName: org?.name,
    workspaceName: workspace?.name,
  };
};
